// Copyright © 2025 CATTLEytics Inc.

import { Stack } from 'react-bootstrap';

export function ReportSection({
  title,
  titleChildren,
  children,
}: {
  children: React.ReactNode;
  title: string;
  titleChildren?: React.ReactNode;
}): JSX.Element {
  return (
    <Stack gap={3}>
      <h2 className="mt-4 ">{title}</h2>
      {titleChildren ? <div>{titleChildren}</div> : null}
      <div className="report-section">{children}</div>
    </Stack>
  );
}
